module.exports = __webpack_public_path__ + "a9d6a893193bb75f4427f5f07963d278.svg";